import {
  Component,
  effect,
  EventEmitter,
  inject,
  Input,
  Output,
} from '@angular/core';
import { CustomGridStackWidget } from '../../../services/grid-widget-config.service';
import { WidgetStore } from '../../../stores/grid/widget.state';
import { getState } from '@ngrx/signals';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { CheckAllComponent } from '../../atoms/check-all/check-all.component';

@Component({
  selector: 'app-wegweiser-widget-config',
  standalone: true,
  imports: [CheckboxModule, FormsModule, CheckAllComponent],
  templateUrl: './wegweiser-widget-config.component.html',
  styleUrl: './wegweiser-widget-config.component.scss',
})
export class WegweiserWidgetConfigComponent {
  readonly widgetStore = inject(WidgetStore);
  @Input() widget!: CustomGridStackWidget;
  @Output() widgetChange = new EventEmitter();

  years: number[] = [];

  constructor() {
    effect(() => {
      const widgetState = getState(this.widgetStore);
      this.setup();
    });
  }

  /**
   * Checks if the given key is not part of the current selection.
   *
   * @param {number} key - The key to check against the selection.
   * @return {boolean} Returns true if the key is not in the selection; otherwise, false.
   */
  isInverseSelected(key: number): boolean {
    // Returns true if the key is NOT in the selection
    return !this.widget.widget.disabledYears.includes(key);
  }

  /**
   * Initializes the `years` property by extracting data from `wegweiserData`
   * within the widget structure. If no data is found, it assigns an empty array.
   *
   * @return {void} Does not return any value.
   */
  setup(): void {
    this.years = this.widget.widget.wegweiserData?.years || [];
  }

  /**
   * Updates the current widget by logging its current state and passing it to the widget store for an update.
   * The update is performed with a forced update option.
   *
   * @return {void} Does not return a value.
   */
  updateWidget(): void {
    this.widgetStore.update(this.widget._id, this.widget, true);
    this.widgetChange.emit();
  }

  /**
   * Toggles the selection state of a given key in the list of disabled years.
   *
   * @param {number} key - The numeric key representing the year to toggle.
   * @param {boolean} isChecked - The current state of the checkbox; true if selected, false if not.
   * @return {void} This method does not return a value.
   */
  toggleSelection(key: number, isChecked: boolean): void {
    if (isChecked) {
      // Remove from selection because the checkbox should act as "deselected"
      this.widget.widget.disabledYears =
        this.widget.widget.disabledYears.filter(item => item !== key);
    } else {
      // Add to selection because the checkbox is "selected"
      this.widget.widget.disabledYears = [
        ...this.widget.widget.disabledYears,
        key,
      ];
    }

    // Notify about the change if necessary
    this.updateWidget();
  }
}
